/* eslint-disable */
<template>
  <v-layout row wrap pa-4 ma-4 class='profile-faq'>
    <v-flex xs12>
      <h1 class='mb-2'>{{ $t('text.faq') }}</h1>
      <v-expansion-panel popout>
        <v-expansion-panel-content v-for='(item, i) in faq' :key='i'>
          <div slot='header'>
            <span v-html='item.question'></span>
          </div>
          <v-card>
            <v-card-text>
              <span v-html='item.answer'></span>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';

export default {
  name: 'profile-faq',
  data() {
    return {
      loaded: false,
      faq: [],
      flag: this.$cookies.get('isoCode')
    };
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  mounted() {
    this.getTermsofservice();
  },
  computed: {
    region() {
      return this.$store.getters.profile.region;
    }
  },
  methods: {
    getTermsofservice() {
      const flag = this.flag;

      axios
        .get(`/faq/${flag}?page=1&limit=100`)
        .then(response => {
          console.info(response.data.faqs);
          this.faq = response.data.faqs;

          this.loaded = true;
          bus.$emit('loading', false);
          bus.$emit('StickySidebarPerfil');

          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>

<style lang='scss'>
@import "../assets/css/_variables";

.profile-faq {
  .v-expansion-panel {
    box-shadow: none !important;

    &__container {
      max-width: 100%;
    }

    &__header {
      height: auto;
      padding: 12px 0;

      &:hover {
        color: $primary;
        transition: all 0.2s ease;
      }
    }

    &__container--active {
      box-shadow: none !important;

      .v-expansion-panel__header {
        color: $primary !important;
        font-weight: 600;
      }
    }
  }
}
</style>
